import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["sidebar"]

    connect() {
        this.handleResize = this.handleResize.bind(this)
        window.addEventListener('resize', this.handleResize)
    }

    disconnect() {
        window.removeEventListener('resize', this.handleResize)
    }

    toggle(event) {
        event.preventDefault()
        console.log("called toggle")

        if (this.sidebarTarget.classList.contains("d-none")) {
            this.sidebarTarget.classList.remove("d-none")
            this.sidebarTarget.classList.add("d-block")
        } else {
            this.sidebarTarget.classList.remove("d-block")
            this.sidebarTarget.classList.add("d-none")
        }
    }

    handleResize() {
        if (window.innerWidth > 768) {
            this.sidebarTarget.classList.remove("d-block")
            this.sidebarTarget.classList.add("d-none")
        }
    }
}